// extracted by css-extract-rspack-plugin
export default {"summaryText":"rbPrTQ3liMPwJ_hl","projectTypeTitle":"A2sRrUHwFMcdm8kL","heading":"W5Dl1cgFkosMUTkT","actions":"OTMZNumN2cQAlMvg"};